import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, Outlet } from "react-router-dom";
import PropertyListComponent from "../propertyNew/PropertyListComponent";
import "./Myspace.css";

const DEFAULT_FILTER_OPTIONS = [
  { label: "Properties", value: "property" },
  { label: "Posts", value: "post" },
  { label: "Saved", value: "follow" },
  { label: "Shared", value: "Shared" },
];

const Myspace = ({
  initialFilter = "property",
  routeBase = "/customer/workspace",
  showFilters = true,
  filterOptions = DEFAULT_FILTER_OPTIONS,
  sectionTitle = "",
}) => {
  const { Id } = useParams();
  const authUser = useSelector((state) => state.auth?.user);
  const userKey = authUser?.user?.id || authUser?.id || authUser?.userDetails?.id || "anon";
  const [selectedValue, setSelectedValue] = useState(initialFilter);

  const handleFilterChange = (event) => {
    const nextValue = event.currentTarget.dataset.value;

    if (!nextValue) {
      return;
    }

    setSelectedValue(nextValue);
  };

  useEffect(() => {
    setSelectedValue(initialFilter);
  }, [initialFilter]);

  return (
    <div className="myspace">
      <div className="myspace__content">
        <div className="myspace__heading mb-2">
          <div>
            <h1 className="myspace__heading-title" style={{ fontSize: "1.75rem", fontFamily: "inherit", fontWeight: 700 }}>
              {sectionTitle || "MySpace Content"}
            </h1>
            <p className="text-muted small mb-0 mt-1">
              Manage, filter, and track your active properties, posts, and saved collections.
            </p>
          </div>
        </div>

        {showFilters ? (
          <div className="myspace__filter-bar">
            <span className="myspace__filter-label">Filter by</span>
            <div className="myspace__filter-pills">
              {filterOptions.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  data-value={opt.value}
                  onClick={handleFilterChange}
                  className={`myspace__pill${
                    selectedValue === opt.value ? " myspace__pill--active" : ""
                  }`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        ) : null}

        <div className="myspace__body">
          {Id ? (
            <Outlet />
          ) : (
            <PropertyListComponent
              key={`${userKey}:${routeBase}`}
              route={routeBase}
              apiPath="/property/list/my/space"
              method="POST"
              requiresAuth={true}
              mySpace={true}
              selectedValue={selectedValue}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Myspace;
